function t(t){return Object.assign({},t,{left:t.x,top:t.y,right:t.x+t.width,bottom:t.y+t.height})}export{t as default};
//# sourceMappingURL=rectToClientRect.js.map
